import React from "react";
import styled from "styled-components";
import SkewBg from "../../Utils/SkewBg";
import PageHeader from "../../Utils/PageHeader";
import { ThemeContext } from "../../ContextProvider/ThemeContextProvider";

const ExperienceWrapper = styled.section`
  position: relative;
  margin-bottom: 400px;
  padding-top: 5px;
  @media screen and (max-width: 968px) {
    position: relative;
    margin-bottom: 300px;
  }
  @media screen and (max-width: 768px) {
    position: relative;
    margin-bottom: 30vw;
  }
`;
const ExperienceInfo = styled.div`
  width: 60%;
  margin: auto;
  margin-top: 200px;
  position: relative;
  z-index: 4;
  color: #f8f8f8;
  font-size: 1.2rem;
  line-height: 2rem;
  @media screen and (max-width: 768px) {
    margin-top: 100px;
  }
`;

const Experience = () => {
  const { mode } = React.useContext(ThemeContext);
  return (
    <ExperienceWrapper id="experience">
      <PageHeader theme={mode}>Experience</PageHeader>
      <SkewBg theme={mode} />
      <ExperienceInfo>
        <ul>
          <li>Worked on the front end part of profile section of the lms.</li>
          <li>
            Developed a Live Quiz App 'Masai Refresh', that is currently being
            used by over 200+ students for interview preparations.
          </li>
          <li>Worked on the industry standard project e.g pankhuri.</li>
          <li>
            Was leading a batch of 50+ student, and resolved their doubts on
            react, js ,redux etc.,delivered lectures on topics required.
          </li>
        </ul>
      </ExperienceInfo>
    </ExperienceWrapper>
  );
};

export default Experience;
